import * as React from 'react';
import { Backdrop, type BackdropProps, styled } from '@mui/material'
import type { ComponentType } from 'react'
import { useOverlayContent } from './ConversationApiProvider.js'

export function ConversationOverlay() {
  const children = useOverlayContent()

  const open = Boolean(children)

  return (
    <ConversationBackdrop aria-hidden={!open} open={open}>
      {children}
    </ConversationBackdrop>
  )
}

const ConversationBackdrop = styled(Backdrop, {
  slot: 'Backdrop',
})<BackdropProps>(({ theme }) => ({
  position: 'absolute',
  zIndex: theme.zIndex.tooltip,
})) as ComponentType<BackdropProps>
